import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
	selector: 'page-tab-calls',
	templateUrl: 'tab-calls.html',
})
export class TabCallsPage {
	public days;
	constructor(
		public navCtrl: NavController,
		public navParams: NavParams
	){
	}
	
	ionViewDidLoad() {
		this.days=[
			{
				label:'Oggi',
				calls:[{
					time:'08:27',
					image:'http://lorempixel.com/128/128/people/?random=1',
					answered:false
				}]
			},{
				label:'Ieri',
				calls:[
					{
						time:'15:30',
						image:'http://lorempixel.com/128/128/people/?random=2',
						answered:true
					},{
						time:'11:21',
						image:'http://lorempixel.com/128/128/people/?random=3',
						answered:false
					}
				]
			},{
				label:'08/10/2017',
				calls:[
					{
						time:'09:11',
						image:'http://lorempixel.com/128/128/people/?random=4',
						answered:false
					},{
						time:'14:00',
						image:'http://lorempixel.com/128/128/people/?random=5',
						answered:true
					}
				]
			}
		];
		//console.log('ionViewDidLoad TabCallsPage');
	}
	
}



// WEBPACK FOOTER //
// ./src/pages/tab-calls/tab-calls.ts